import {
  ComponentFactoryResolver,
  Injector,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';

import { WysiwygAdapterService } from './wysiwyg-adapter.service';
import {
  WysiwygEmbeddableComponents,
  WysiwygEmbeddableComponentType,
} from './wysiwyg-adapter.types';

export const adapterServiceFactory = (
  injector: Injector,
  cfr: ComponentFactoryResolver,
  parent?: WysiwygAdapterService,
) => (parent ? parent : new WysiwygAdapterService(injector, cfr));

export const ADAPTER_SERVICE_PROVIDER = {
  provide: WysiwygAdapterService,
  useFactory: adapterServiceFactory,
  deps: [
    Injector,
    ComponentFactoryResolver,
    [new Optional(), new SkipSelf(), WysiwygAdapterService],
  ],
};

@NgModule()
export class WysiwygAdapterModule {
  public static provideEmbeddableComponent(
    component: WysiwygEmbeddableComponentType,
  ): ModuleWithProviders<WysiwygAdapterModule> {
    return {
      ngModule: WysiwygAdapterModule,
      providers: [
        {
          provide: WysiwygEmbeddableComponents,
          useValue: component,
          multi: true,
        },
        ADAPTER_SERVICE_PROVIDER,
      ],
    };
  }
}
